import React from "react";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";

// Section A: public. "رواق" has no content yet — a plain "به‌زودی..."
// placeholder centered on the page until it does. Mirrors the empty-state
// treatment used elsewhere (e.g. AdminFeaturedPage's "به‌زودی" slots).
function RavaqPage() {
  return (
    <div className="site">
      <SiteHeader />

      <main className="coming-soon">
        <p className="coming-soon-text">به‌زودی...</p>
      </main>

      <SiteFooter />
    </div>
  );
}

export default RavaqPage;
